<template>
  <div class="w-full p-4 flex flex-col">
    <section class="flex flex-col w-full mt-4 mb-8">
      <h2 class="text-2xl font-bold mb-4 text-center">polarアカウント連携</h2>
    </section>
  </div>
</template>

<script lang="ts">
import firebase from "firebase/app";
import { Vue } from "vue-class-component";
import store from "@/store";
import { awaitStudentLoaded } from "@/store/index";
import { withTimeout } from "@/utils/timeout";

export default class PolarAuthRedirect extends Vue {
  code = "";

  clearUrl() {
    window.history.pushState(
      {},
      "",
      window.location.origin + window.location.pathname
    );
  }

  async created() {
    const TIMEOUT_SEC = 10;

    try {
      await withTimeout(awaitStudentLoaded(store), 1000 * TIMEOUT_SEC);

      store.commit("SET_LOADING", true);
      store.commit("SET_LOAD_TEXT", "処理中...");

      const searchParams = new URLSearchParams(window.location.search);
      const code: string | null = searchParams.get("code");
      const error: string | null = searchParams.get("error");

      if (error) {
        throw new Error(error);
      }

      if (!code) {
        throw new Error(`code is not found.`);
      }

      this.code = code;

      this.clearUrl();

      const call = firebase
        .app()
        .functions("asia-northeast1")
        .httpsCallable("link_student_to_polar");
      const res = await call({ code });

      if (!res.data.success) {
        throw new Error("Something went wrong");
      }

      store.commit("SET_LOADING", false);
      store.commit("SET_LOAD_TEXT", "");

      window.location.href = "/learning_card";
    } catch (e) {
      console.error(e);
      alert(
        `エラーが発生しました。` +
          "\n" +
          (e instanceof Error ? e.message : "unknown error")
      );

      this.clearUrl();
      store.commit("SET_LOADING", false);
      store.commit("SET_LOAD_TEXT", "");
      this.$router.push("/");
    }
  }
}
</script>
